/**
 * Navigation callbacks for <ClerkProvider routerPush/routerReplace>.
 *
 * Without them, Clerk's setActive() (run after every sign-in and sign-up)
 * blanks the session, assigns window.location to the redirect URL and treats
 * the page as unloading, so it never restores the session itself. On this
 * hash-routed dashboard the redirect is often the current URL or differs only
 * by hash (a modal opened on `#/scan/<id>`), which the browser handles as a
 * fragment navigation with no reload: the app then sat on "Initializing
 * Privisy..." with a valid session. With a router configured, Clerk awaits it
 * and only skips the restore when a real `beforeunload` fires, so a
 * same-document target settles in place and any other target still gets a
 * full page load.
 */
type NavigableLocation = Pick<Location, 'href' | 'assign' | 'replace'>;

export function makeClerkRouter(loc: NavigableLocation = window.location) {
  const resolve = (to: string) => new URL(to, loc.href).href;
  return {
    routerPush: (to: string): void => loc.assign(resolve(to)),
    routerReplace: (to: string): void => loc.replace(resolve(to)),
  };
}
